import '../../css/levelProfilePage/levelProfilePage.css';
import MyEx from '../../components/levelProfile/MyEx'; 

const LevelProfileBody = () => {
  return (
    <div> 
        <div>
            <MyEx />
        </div>
    </div>
  );
};

export default LevelProfileBody;